
export function getTimeAgo(timestamp: number | any): string {
    if (!timestamp) return '';

    // In case of Firestore Timestamp object
    const date = typeof timestamp === 'number' ? timestamp : (timestamp.toMillis ? timestamp.toMillis() : Date.parse(timestamp));

    const now = Date.now();
    const seconds = Math.floor((now - date) / 1000);

    if (seconds < 60) return 'Az önce';
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes} dk önce`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} sa önce`;
    const days = Math.floor(hours / 24);
    if (days < 7) return `${days} gün önce`;
    if (days < 30) return `${Math.floor(days / 7)} hf önce`;

    return new Date(date).toLocaleDateString('tr-TR', {
        day: 'numeric',
        month: 'short'
    });
}

export function formatDate(timestamp: number | any): string {
    if (!timestamp) return '';
    const date = typeof timestamp === 'number' ? new Date(timestamp) : (timestamp.toDate ? timestamp.toDate() : new Date(timestamp));
    return date.toLocaleDateString('tr-TR', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });
}
